import styled from 'styled-components';

// Small text primitives shared by the Action Items surfaces.

// Text-style button for secondary actions ("Show closed", "+ Action Item from this Note").
export const LinkButton = styled.button`
  background: none;
  border: none;
  color: #6941C6;
  cursor: pointer;
  font-size: 12px;
  padding: 0;

  &:hover { text-decoration: underline; }
`;

// `$small` for the compact Enablement expanded row.
export const Muted = styled.span<{ $small?: boolean }>`
  color: ${(p) => p.theme.colors.Gray500};
  font-size: ${(p) => (p.$small ? '11px' : '12px')};
`;

export const ErrorText = styled.div`
  color: #B42318;
  font-size: 12px;
`;

// Segmented toggle (board filters, Group by, timeline views).
export const Segmented = styled.div`
  border: 1px solid ${(p) => p.theme.colors.Gray300};
  border-radius: 8px;
  display: inline-flex;
  overflow: hidden;
`;

export const Segment = styled.button<{ $on: boolean }>`
  background: ${(p) => (p.$on ? '#F9F5FF' : 'white')};
  border: none;
  border-right: 1px solid ${(p) => p.theme.colors.Gray300};
  color: ${(p) => (p.$on ? '#6941C6' : p.theme.colors.Gray700)};
  cursor: pointer;
  font-size: 12px;
  font-weight: ${(p) => (p.$on ? 600 : 500)};
  padding: 6px 12px;

  &:last-child { border-right: none; }
`;

// A thin "|" between header or row-action items, e.g. the comment count and a date.
export const Divider = styled.span`
  background: ${(p) => p.theme.colors.Gray300};
  height: 10px;
  width: 1px;
`;

// A drawer section's heading row: the label (and any toggles beside it) on the left, an action such as "+ New" on the right.
export const SectionHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
`;

export const SectionLabel = styled.div`
  color: #101828;
  font-size: 14px;
  font-weight: 600;
`;

export const SectionHeaderStart = styled.div`
  align-items: baseline;
  display: flex;
  gap: 10px;
`;
